export default __webpack_public_path__ + "static/media/star.a63c987a.svg";